import React from 'react';
import PropTypes from 'prop-types';
import Textfield from '../textfield/textfield';

const HiddenField = ({
  className,
  id,
  label,
  type,
  defaultValue,
  defaultLanguage,
  placeholder,
}) => {
  return (
    <Textfield
      type={type}
      label={label}
      id={id}
      defaultValue={defaultValue}
      defaultLanguage={defaultLanguage}
      placeholder={placeholder}
      className={className}
      isHidden={true}
    />
  );
};

HiddenField.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  defaultValue: PropTypes.object,
  defaultLanguage: PropTypes.string,
  placeholder: PropTypes.object,
};

export default HiddenField;
